var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavCoworker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.171,
    height: 16.766,
    viewBox: "0 0 20.171 16.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3056",
    "data-name": "Group 3056",
    transform: "translate(-872 -7760.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M14.491,20.7a.723.723,0,0,1-.723-.723v-1.7A2.684,2.684,0,0,0,11.087,15.6H4.278A2.684,2.684,0,0,0,1.6,18.278v1.7a.723.723,0,0,1-1.447,0v-1.7A4.132,4.132,0,0,1,4.278,14.15h6.809a4.132,4.132,0,0,1,4.128,4.128v1.7A.723.723,0,0,1,14.491,20.7Z",
    transform: "translate(871.85 7756.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    d: "M3.278-.85A4.128,4.128,0,1,1-.85,3.278,4.132,4.132,0,0,1,3.278-.85Zm0,6.809A2.681,2.681,0,1,0,.6,3.278,2.684,2.684,0,0,0,3.278,5.959Z",
    transform: "translate(876.254 7761.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M22.427,20.723A.723.723,0,0,1,21.7,20V18.3A2.681,2.681,0,0,0,19.693,15.7a.723.723,0,0,1,.362-1.4,4.128,4.128,0,0,1,3.1,3.994V20A.723.723,0,0,1,22.427,20.723Z",
    transform: "translate(869.021 7756.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M15.873,10.323A.724.724,0,0,1,15.694,8.9a2.681,2.681,0,0,0,0-5.194.723.723,0,0,1,.359-1.4,4.128,4.128,0,0,1,0,8A.725.725,0,0,1,15.873,10.323Z",
    transform: "translate(869.616 7758.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059-2",
    "data-name": "Path 2059",
    d: "M14.491,20.7a.723.723,0,0,1-.723-.723v-1.7A2.684,2.684,0,0,0,11.087,15.6H4.278A2.684,2.684,0,0,0,1.6,18.278v1.7a.723.723,0,0,1-1.447,0v-1.7A4.132,4.132,0,0,1,4.278,14.15h6.809a4.132,4.132,0,0,1,4.128,4.128v1.7A.723.723,0,0,1,14.491,20.7Z",
    transform: "translate(871.85 7756.386)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_8-2",
    "data-name": "Ellipse 8",
    d: "M3.278-.85A4.128,4.128,0,1,1-.85,3.278,4.132,4.132,0,0,1,3.278-.85Zm0,6.809A2.681,2.681,0,1,0,.6,3.278,2.684,2.684,0,0,0,3.278,5.959Z",
    transform: "translate(876.254 7761.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060-2",
    "data-name": "Path 2060",
    d: "M22.427,20.723A.723.723,0,0,1,21.7,20V18.3A2.681,2.681,0,0,0,19.693,15.7a.723.723,0,0,1,.362-1.4,4.128,4.128,0,0,1,3.1,3.994V20A.723.723,0,0,1,22.427,20.723Z",
    transform: "translate(869.021 7756.367)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061-2",
    "data-name": "Path 2061",
    d: "M15.873,10.323A.724.724,0,0,1,15.694,8.9a2.681,2.681,0,0,0,0-5.194.723.723,0,0,1,.359-1.4,4.128,4.128,0,0,1,0,8A.725.725,0,0,1,15.873,10.323Z",
    transform: "translate(869.616 7758.154)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCoworker);
export default __webpack_public_path__ + "static/media/Nav-Coworker.d286ea488e4d6c15686515c62be9ed0c.svg";
export { ForwardRef as ReactComponent };